import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "home.small" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector",
    d: "M10.707 2.293C10.5195 2.10553 10.2651 2.00021 9.99998 2.00021C9.73482 2.00021 9.48051 2.10553 9.29298 2.293L2.29298 9.293C2.11082 9.4816 2.01003 9.7342 2.01231 9.9964C2.01458 10.2586 2.11975 10.5094 2.30516 10.6948C2.49057 10.8802 2.74138 10.9854 3.00358 10.9877C3.26578 10.99 3.51838 10.8892 3.70698 10.707L3.99998 10.414V17C3.99998 17.2652 4.10534 17.5196 4.29287 17.7071C4.48041 17.8946 4.73476 18 4.99998 18H6.99998C7.2652 18 7.51955 17.8946 7.70709 17.7071C7.89462 17.5196 7.99998 17.2652 7.99998 17V15C7.99998 14.7348 8.10534 14.4804 8.29287 14.2929C8.48041 14.1054 8.73476 14 8.99998 14H11C11.2652 14 11.5196 14.1054 11.7071 14.2929C11.8946 14.4804 12 14.7348 12 15V17C12 17.2652 12.1053 17.5196 12.2929 17.7071C12.4804 17.8946 12.7348 18 13 18H15C15.2652 18 15.5196 17.8946 15.7071 17.7071C15.8946 17.5196 16 17.2652 16 17V10.414L16.293 10.707C16.4816 10.8892 16.7342 10.99 16.9964 10.9877C17.2586 10.9854 17.5094 10.8802 17.6948 10.6948C17.8802 10.5094 17.9854 10.2586 17.9877 9.9964C17.9899 9.7342 17.8891 9.4816 17.707 9.293L10.707 2.293V2.293Z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }